import i from"styled-components";import{Icon as e}from"../../common/Modal/ModalHeader/ModalHeader.styles.js";import{theme as t}from"../../../theme.js";const n=i.div`
  display: grid;
  grid-template-columns: 400px 1fr;
  height: 100%;
  position: relative;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    > div {
      width: 500px;
    }
  }
  .image {
    > img {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }
  }
  @media screen and (max-width: ${t.breakpoints.lg}),
  screen and (max-height: 700px) {
    grid-template-columns: 1fr;
    .image {
      display: none;
    }
    .content {
      width: 100%;
      padding: ${t.spacing*4}px;
      display: block;
      > div {
        width: calc(100% - 32px);
      }
    }
  }
`,o=i.h1`
  font-size: 32px;
  font-weight: 700;
  color: ${t.colors.gray[900]};
  margin: 0 0 ${t.spacing*2}px;
  &.center {
    text-align: center;
  }
`,p=i.p`
  margin: 0 0 ${t.spacing*6}px;
  color: ${t.colors.gray[500]};
  &.center {
    text-align: center;
  }
`,a=i.div`
  display: flex;
  justify-content: flex-end;
  gap: ${t.spacing*4}px;
  margin-top: ${t.spacing*4}px;
`,r=i.div`
  padding: ${t.spacing*4}px;
`,c=i(e)`
  position: absolute;
  top: 16px;
  right: 16px;
`;export{a as ButtonsContainer,c as CloseButton,n as Container,r as MobileContainer,p as StepDescription,o as StepTitle};
